import { buildApiUrl, Type, sendGetRequest } from '@/api/api'
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export const regionSchema = z.array(z.object({
  Id: z.number(),
  Name: z.string()
}))

export async function fetch() {
  const url = buildApiUrl(Type.Core, `tariffs/provinces`)
      const { data } = await sendGetRequest(url)
  return assertSchemaAndCoerce(data, regionSchema)
}
